import React from "react";
import useStyled from "../../../hooks/useStyled";

const { styled } = useStyled();

const StyledTooltip = styled("div")(({ theme }) => ({
  padding: theme.spacing(0.5),
  position: "relative",
  border: `1px solid ${theme.palette.white.main}`,
  borderRadius: 5,
  transform: "translate(-50%, -100%)",
  "&:after": {
    content: "''",
    position: "absolute",
    bottom: "-3px",
    left: "50%",
    transform: "translateX(-50%) rotate(-45deg)",
    boxShadow: "-3px 3px 4px -3px rgba(0, 0, 0, 0.25)",
    boxSizing: "border-box",
    border: `3px solid ${theme.palette.black.main}`,
    borderColor: "transparent transparent #fff #fff",
    width: 0,
    height: 0
  },
}));

const CustomTooltip = (props) => {
  return <StyledTooltip>{props.children}</StyledTooltip>;
};

export default CustomTooltip;
